// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-landing-social[data-v-6b062f6c]{padding:54px 0}@media screen and (min-width:1134px){.k-landing-social[data-v-6b062f6c]{padding:90px 0}}@media screen and (min-width:600px){.k-landing-social__content[data-v-6b062f6c]{margin-left:21px}}@media screen and (min-width:960px){.k-landing-social__content[data-v-6b062f6c]{margin-left:85px}}.k-landing-social__text[data-v-6b062f6c]{max-width:404px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
